import * as React from 'react';
const MessageIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_1372_2683"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={25}
      height={24}
    >
      <rect x={0.34375} width={24} height={24} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1372_2683)">
      <path
        d="M3.83318 16.2615C3.51651 15.5846 3.2726 14.891 3.10145 14.1806C2.93029 13.4703 2.8447 12.7434 2.8447 12C2.8447 10.6858 3.09404 9.45082 3.5927 8.295C4.09137 7.13917 4.76812 6.13375 5.62295 5.27875C6.4778 4.42375 7.48305 3.74688 8.63868 3.24813C9.7943 2.74938 11.0291 2.5 12.343 2.5C13.6569 2.5 14.892 2.74933 16.0481 3.248C17.2043 3.74667 18.2099 4.42342 19.0652 5.27825C19.9204 6.1331 20.5974 7.13834 21.0963 8.29398C21.5952 9.44959 21.8447 10.6844 21.8447 11.9983C21.8447 13.3122 21.5953 14.5473 21.0965 15.7034C20.5978 16.8595 19.9209 17.8652 19.0659 18.7204C18.2109 19.5757 17.2055 20.2527 16.0497 20.7516C14.8938 21.2505 13.6588 21.5 12.3447 21.5C11.6013 21.5 10.8744 21.4144 10.1641 21.2432C9.4537 21.0721 8.76007 20.8281 8.08315 20.5115L3.65868 21.807C3.31605 21.9113 3.01749 21.8361 2.763 21.5816C2.5085 21.3272 2.43338 21.0286 2.53763 20.686L3.83318 16.2615ZM4.29468 20.05L7.49468 19.1C7.74083 19.0333 7.97833 19.0051 8.20718 19.0154C8.43603 19.0256 8.6652 19.0872 8.89468 19.2C9.42801 19.4666 9.98635 19.6666 10.5697 19.8C11.153 19.9333 11.7447 20 12.3447 20C14.578 20 16.4697 19.225 18.0197 17.675C19.5697 16.125 20.3447 14.2333 20.3447 12C20.3447 9.76664 19.5697 7.87498 18.0197 6.32498C16.4697 4.77498 14.578 3.99998 12.3447 3.99998C10.1113 3.99998 8.21968 4.77498 6.66968 6.32498C5.11968 7.87498 4.34468 9.76664 4.34468 12C4.34468 12.6 4.41135 13.1916 4.54468 13.775C4.67801 14.3583 4.87801 14.9166 5.14468 15.45C5.26135 15.6666 5.32545 15.8958 5.33698 16.1375C5.34853 16.3791 5.31776 16.6166 5.24468 16.85L4.29468 20.05Z"
        fill="#1A1A1A"
      />
    </g>
  </svg>
);
export default MessageIcon;
